import { render, staticRenderFns } from "./invasions-page.vue?vue&type=template&id=598fc688&lang=pug&"
import script from "./invasions-page.vue?vue&type=script&lang=js&"
export * from "./invasions-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports